module.exports = __webpack_public_path__ + "static/media/CategoryIcon.0b4b4974.svg";